// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
var mwith = function (dictMonoid) {
    var mempty = Data_Monoid.mempty(dictMonoid);
    return function (v) {
        return function (v1) {
            if (v instanceof Data_Maybe.Just) {
                return v1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return mempty;
            };
            throw new Error("Failed pattern match at Data.Monoid.Extra (line 23, column 1 - line 23, column 58): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var mwhen = function (dictMonoid) {
    var mempty = Data_Monoid.mempty(dictMonoid);
    return function (v) {
        return function (v1) {
            if (!v) {
                return mempty;
            };
            if (v) {
                return v1;
            };
            throw new Error("Failed pattern match at Data.Monoid.Extra (line 13, column 1 - line 13, column 49): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var munless = function (dictMonoid) {
    var mempty = Data_Monoid.mempty(dictMonoid);
    return function (v) {
        return function (v1) {
            if (v) {
                return mempty;
            };
            if (!v) {
                return v1;
            };
            throw new Error("Failed pattern match at Data.Monoid.Extra (line 18, column 1 - line 18, column 51): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var fromEmpty = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (dictMonoid) {
        var mempty = Data_Monoid.mempty(dictMonoid);
        return function ($$default) {
            return function (value) {
                var $23 = eq(value)(mempty);
                if ($23) {
                    return $$default;
                };
                return value;
            };
        };
    };
};
export {
    mwhen,
    munless,
    mwith,
    fromEmpty
};
